<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-50" cols="6">
        <v-row class="h-25">CPU :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3">
            <span class="text-h4 mr-1">{{ cpu }}</span>
            <span class="text-h7">%</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="h-50" cols="6">
        <v-row class="h-25">Memory :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3">
            <span class="text-h4 mr-1">{{ memory }}</span>
            <span class="text-h7">%</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';

export default {
  mixins: [instanceable, contextmenuable],
  data() {
    return {
      osCpu: {
        cpu: 0,
      },
      osInfo: {
        cpu: 0,
        memory: 0,
      },
      osMem: {
        memory: 0,
      },
      contextmenuUrl: '/views/detailview/java/os',
    };
  },
  computed: {
    cpu() {
      return this.osCpu.cpu || this.osInfo.cpu;
    },
    memory() {
      return this.osMem.memory || this.osInfo.memory;
    },
  },
  methods: {
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => every(key, response.length ? response[response.length - 1].data : []));
    },
    wsDataHandler(key, response) {
      const [data] = response;
      if (key.name == 'rawJavaOsCpu') this.cpuDataHandler(data || {});
      else if (key.name == 'rawJavaOsInfo') this.infoDataHandler(data || {});
      else if (key.name == 'rawJavaOsMem') this.memDataHandler(data || {});
    },
    cpuDataHandler(data) {
      this.osCpu.cpu = parseInt(data.usr || 0) + parseInt(data.sys || 0);
    },
    infoDataHandler(data) {
      this.osInfo = {
        cpu: data.cpuUtil || 0,
        memory: data.memUtil || 0,
      };
    },
    memDataHandler(data) {
      const memFree = parseInt(data.memFree || 0);
      const memSize = parseInt(data.memSize || 0);
      this.osMem.memory = memFree && memSize ? Math.floor((1 - memFree / memSize) * 100) : 0;
    },
  },
  created() {
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: 'rawJavaOsCpu', sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
          fields: ['usr', 'sys'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
        {
          key: { name: 'rawJavaOsInfo', sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
          fields: ['cpuUtil', 'memUtil'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
        {
          key: { name: 'rawJavaOsMem', sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
          fields: ['memFree', 'memSize'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
      ],
    });
  },
};
</script>
